<template>
  <div class="content">
    <h1 class="has-text-centered">
      My AHL
    </h1>
    <hr>
    <div class="columns">
      <div class="column is-6">
        <div class="box">
          <div class="heading">
            <strong>AHL Today</strong>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="box">
          <div class="heading">
            <strong>AHL Special Events</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="box">
          <div class="heading">
            <strong>AHL News</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MyAhl',
    data () {
      return {}
    },
    methods: {}
  }
</script>